import {
  ActivityType,
  BolusState,
  PumpSuspendReason,
} from "@tandemdiabetes/sugarmate-api-react-client"

import type { ReadOnlyUserEvent } from "src/types"

// Events that are noise or not actionable are excluded from the graph.
export function shouldHideEventFromGraph(userEvent: ReadOnlyUserEvent): boolean {
  // Initiated boluses are not actionable.
  if (
    userEvent.event_type === ActivityType.Bolus &&
    userEvent.bolus.state === BolusState.Initiated
  ) {
    return true
  }

  // Algorithm-driven (BIQ/CIQ) pump suspensions are noise.
  if (
    userEvent.event_type === ActivityType.PumpSuspension &&
    (userEvent.pump_suspension.suspend_reason === PumpSuspendReason.BIQSuspend ||
      userEvent.pump_suspension.suspend_reason === PumpSuspendReason.CIQSuspend)
  ) {
    return true
  }

  return false
}
